import React, { useState, useEffect, useRef } from 'react';
import axios from '../api/axiosInstance';
import './ParkingMap.css';
import styles from './ParkingMap.css';

function ParkingMap({ selectedDates, onSelectSpot, selectedSpot, currentUserId, mouseSelecting }) {
  const [spots, setSpots] = useState([]);
  const [tappedSpotId, setTappedSpotId] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [floors, setFloors] = useState([]);
  
  const mapRef = useRef(null);
  const HOST = process.env.REACT_APP_HOST;
  const PORT = process.env.REACT_APP_API_PORT;
  const baseUrl = useRef(`https://${HOST}`).current;
  const scale_x = 0.6;
  const scale_y = 0.6;

  const prevDatesRef = useRef([]);

  const formatDateList = (dateArray) => {
    if (!dateArray || dateArray.length === 0) return "brak";
    
    return dateArray
      .map((isoStr) => {
        const date = new Date(isoStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const weekday = date.toLocaleDateString('pl-PL', { weekday: 'short' });
        return `${weekday} - ${day}.${month}`;
      })
      .join('\n');
  };
  
// 1. Piętra – tylko raz przy pierwszym załadowaniu
useEffect(() => {
  const fetchFloors = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const res = await axios.get(`${baseUrl}/api/admin/floors`);

      const fetchedFloors = res.data;
      setFloors(fetchedFloors);

      // odczytujemy z localStorage ostatnie piętro
      const storedFloor = localStorage.getItem('selectedFloor');

      if (storedFloor && fetchedFloors.includes(storedFloor)) {
        setSelectedFloor(storedFloor);
      } else if (fetchedFloors.length > 0) {
        setSelectedFloor(fetchedFloors[0]);
      }

    } catch (err) {
      console.error("❌ Błąd pobierania pięter:", err);
    }
  };

  fetchFloors();
}, []);

// 2. Miejsca – przy zmianie daty lub piętra, ale NIE gdy przeciągasz myszą
const lastDatesRef = useRef([]);

useEffect(() => {
  const sameDates =
    JSON.stringify(lastDatesRef.current) === JSON.stringify(selectedDates);

  if (mouseSelecting || !selectedFloor || sameDates) return;

  lastDatesRef.current = selectedDates;

  const fetchSpots = async () => {
    try {
      if (selectedDates && selectedDates.length > 0) {
        const dateStrings = selectedDates.map(d => d.toISOString().split('T')[0]);
        const res = await axios.get(`${baseUrl}/api/reservations/spots`, {
          params: { dates: dateStrings, floor: selectedFloor }
        });
        setSpots(res.data);
      } else {
        const res = await axios.get(`${baseUrl}/api/admin/parking-spots`, {
          params: { floor: selectedFloor }
        });
        setSpots(res.data);
      }
    } catch (err) {
      console.error("Błąd pobierania miejsc parkingowych:", err);
    }
  };

  fetchSpots();
}, [selectedDates, selectedFloor, mouseSelecting]);


  

  const handleSpotClick = (spot) => {
    if (onSelectSpot) {
      onSelectSpot(selectedSpot && selectedSpot.id === spot.id ? null : spot);
    }
  };
  const getContainerSize = () => {
    const maxX = Math.max(...spots.map(s => s.x_position)) * scale_x + 100;
    const maxY = Math.max(...spots.map(s => s.y_position)) * scale_y + 100;
  
    return {
      width: `${Math.ceil(maxX)}px`,
      height: `${Math.ceil(maxY)}px`
    };
  };
  return (
    <div className="parking-map-wrapper">
      {floors.length > 0 && (
        <div className="floor-tabs">
          {floors.map((floor) => (
            <button
            key={floor}
            className={`floor-tab ${selectedFloor === floor ? 'active' : ''}`}
            onClick={() => {
              setSelectedFloor(floor);
              localStorage.setItem('selectedFloor', floor); // 💾 Zapisujemy wybrane piętro
            }}
          >
            {floor}
          </button>
          ))}
        </div>
      )}
    
      <div className="parking-map-container-reservation-view" ref={mapRef} style={getContainerSize()}>
        <div className='parking-map-inner-wrapper'>
          {spots
            .filter(spot => spot.floor?.toString().trim() === selectedFloor?.toString().trim())
            .map((spot) => {
              const isSelected = selectedSpot && selectedSpot.id === spot.id;
              const reservations = spot.reservations || [];
              const dateStrs = selectedDates.map(d => d.toISOString().split("T")[0]);
  
              const reservedDates = reservations.filter(r => dateStrs.includes(r.date));
              const reservedByMe = reservedDates.length > 0 &&
                reservedDates.every(r => r.userId === currentUserId);
              const reservedByOthers = reservedDates.filter(r => r.userId !== currentUserId);
  
              const mineDates = reservedDates
                .filter(r => r.userId === currentUserId)
                .map(r => r.date)
                .sort();
  
              const othersDates = reservedDates
                .filter(r => r.userId !== currentUserId)
                .map(r => r.date)
                .sort();
  
              const availableDates = dateStrs.filter(
                date => !reservedDates.some(r => r.date === date)
              );
  
              const tooltipText =
                mineDates.length === dateStrs.length
                  ? `To Twoje miejsce.`
                  : mineDates.length > 0 && othersDates.length === 0
                  ? `Twoje rezerwacje:\n${formatDateList(mineDates)}\n\nDostępne dni:\n${formatDateList(availableDates)}`
                  : mineDates.length > 0 && othersDates.length > 0
                  ? `Twoje rezerwacje:\n${formatDateList(mineDates)}\n\nZajęte:\n${formatDateList(othersDates)}\n\nDostępne:\n${formatDateList(availableDates)}`
                  : othersDates.length === dateStrs.length
                  ? `Zajęte.`
                  : othersDates.length > 0
                  ? `Zajęte:\n${formatDateList(othersDates)}\n\nDostępne:\n${formatDateList(availableDates)}`
                  : `Dostępne.`;
  
              const spotClass =
                mineDates.length > 0
                  ? "mine"
                  : othersDates.length === dateStrs.length
                  ? "reserved"
                  : othersDates.length > 0
                  ? "partially-taken"
                  : "free";
  
              const classes = [
                "parking-spot-box",
                spotClass,
                isSelected ? "selected" : "",
                tappedSpotId === spot.id ? "show-tooltip" : ""
              ].join(" ");
  
              return (
                <div
                  key={spot.id}
                  className={classes}
                  data-tooltip={tooltipText}
                  style={{
                    left: `${spot.x_position * scale_x}px`,
                    top: `${spot.y_position * scale_y}px`
                  }}
                  onClick={() => {
                    handleSpotClick(spot);
                    setTappedSpotId(tappedSpotId === spot.id ? null : spot.id);
                  }}
                >
                  {spot.spotNumber}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
  
}

export default ParkingMap;
